/**
 * Checks if the current rendering device has a touch screen.
 */
export function isTouchableDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

/**
 * Checks if the current environment is a mobile web view (iOS or Android).
 * Only use this where you specifically need to identify our app.
 * Mobile device detection in general should be done using @breakpointMobile in CSS and useBreakpoint() in react.
 */
export function isMobileApp() {
  const webViewRegexes = [
    // WebView for both iOS and Android
    /WebView/,
    // iOS webview will be the same as safari but missing "Safari"
    /(iPhone|iPod|iPad)(?!.*Safari)/,
    // Android WebView: contains "wv" or specific Chrome version pattern
    /Android.*(;\s+wv|Version\/\d.\d\s+Chrome\/\d+(\.0){3})/,
    // Older Android WebView user agent
    /Linux; U; Android/
  ];

  const userAgent = navigator.userAgent;

  return webViewRegexes.some(regex => regex.test(userAgent));
}

/**
 * Show the browser (body) in fullscreen mode
 *
 */
export function requestFullScreenMode() {
  //different versions are necessary to work on ipad/safari https://web.dev/native-hardware-fullscreen/
  const docEl = document.body;
  const requestMethod =
    docEl.requestFullscreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    docEl.mozRequestFullScreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    docEl.webkitRequestFullScreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    docEl.msRequestFullscreen;

  if (requestMethod) {
    requestMethod.apply(docEl);
  }
}

/**
 * Exit fullscreen mode of the browser
 *
 */
export function exitFullScreenMode() {
  //different versions are necessary to work on ipad/safari https://web.dev/native-hardware-fullscreen/
  const doc = window.document;
  const cancelFullScreen =
    doc.exitFullscreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    doc.mozCancelFullScreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    doc.webkitExitFullscreen ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    doc.msExitFullscreen;
  cancelFullScreen.call(doc);
}
